module.exports = __webpack_public_path__ + "img/china-petroleum-bind-logo.8e6b7613.png";